export default __webpack_public_path__ + "static/media/welcome.6fb202fb.png";